import * as emailAddresses from 'email-addresses';

export function isValidEmail(email: string): boolean {
    if (typeof email !== 'string' || email.length === 0) {
        return false;
    }

    if (email !== email.trim() || /\s/.test(email)) {
        return false;
    }

    const parseOneAddress =
        (emailAddresses as { parseOneAddress?: unknown }).parseOneAddress ??
        (emailAddresses as { default?: { parseOneAddress?: unknown } }).default?.parseOneAddress;

    if (typeof parseOneAddress !== 'function') {
        return false;
    }

    const parsed = parseOneAddress({
        input: email,
        rfc6532: false,
        strict: false,
        rejectTLD: false,
    });

    if (parsed === null || parsed.type !== 'mailbox') {
        return false;
    }

    return parsed.name === null && parsed.address === email;
}
